module.exports = __webpack_public_path__ + "img/3-images-tt.dc457060.png";